import React, { useEffect, useState, useContext } from 'react';
import {Link, useParams} from 'react-router-dom';
import { Contextone } from './Context';
import styled from 'styled-components';
import {fetchSearch} from './Api';
import subscribe from '../images/premium.png';
import rentIcon from '../images/rentIcon.png'

// Shimmer effect components
const ShimmerContainer = styled.div`
  height: 230px;
  width: 178px;
  margin: 0 10px 30px 0;
  background: #3a3a3a;
  background-image: linear-gradient(to right, #3a3a3a 0%, #3f3f3f 10%, #4a4a4a 20%, #3f3f3f 30%, #3a3a3a 50%, #3a3a3a 100%);
  background-repeat: no-repeat;
  background-size: 1900px 800px;
  position: relative;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: ease-in-out;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;

const ShimmerRow = () => (
  <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', marginTop: '15vh' }}>
    {[...Array(14)].map((_, index) => (
      <ShimmerContainer key={index} />
    ))}
  </div>
);

const Search = ({ match }) => {
    const [videoData, setVideoData] = useState([]);
    const [seriesData, setSeriesData] = useState([]);
    const [loading, setLoading] = useState(false);
    const countercontext = useContext(Contextone);
    const isurl = countercontext.isDomain;
    const apiUrl = `https://${isurl}`;
    const {name} = useParams();
    const logo = countercontext.isLogo;

    const handleImageLoad = (index) => {
        setImageLoaded((prevState) => ({
            ...prevState,
            [index]: true, 
        }));
    };

    const [imageLoaded, setImageLoaded] = useState({});  

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = await fetchSearch(apiUrl,name);
                let vid = data.video;
                let seriesVid = data.tvshow;
                setVideoData(vid);
                setSeriesData(seriesVid)
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [name]);

    const addDefaultImg = ev => {
        ev.target.src = logo;
     }

     const slugify = (text) => {
        return text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
      };
      
      const decodeVal = (str) => {
        return btoa(str);
      }
      
      const createEncodedData = (id, type_id, video_type, upcoming_type) => {
        const str = `${id}-${type_id}-${video_type}-${upcoming_type}`; 
        return decodeVal(str); 
      };

    const isDataAvailable = videoData.length > 0;
    const isSeriesAvailable = seriesData.length > 0;

    return (
        <>
            <div>
                {loading ? (
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <ShimmerRow />
                    </div>
                ) : (
                    isDataAvailable || isSeriesAvailable ? (
                        <div className="view-list">
                        {videoData.map((movie, key) => (
                            <div className="custom-div" key={key}>
                                <div className="card movie-card">
                                {isurl ==='mahuaplay.ottsnap.in'&& movie.type_id !== 5 &&
                                    <Link to={`/search/${slugify(movie.name)}/${createEncodedData(movie.id,movie.type_id, movie.video_type, movie.upcoming_type)}`} >
                                    {(movie.is_premium || movie.is_rent !== 0) && (
                                          <img
                                            src={movie.is_premium ? subscribe : rentIcon}
                                            className={`premium-img ${movie.is_premium ? 'premium-style' : ''}`}
                                            alt="Premium/Rent Icon"
                                          />
                                        )}
                                        {movie.thumbnail ? (
                                            <img src={imageLoaded[key] ? movie.thumbnail : logo} 
                                            onLoad={() => handleImageLoad(key)} 
                                            onError={addDefaultImg}
                                            className="img-top" alt={movie.name} style={{ height: '230px' }} />
                                        ) : (
                                            <img src={imageLoaded[key] ? movie.image : logo} 
                                            onLoad={() => handleImageLoad(key)} 
                                            onError={addDefaultImg}
                                            className="img-top" alt={movie.name} style={{ height: '230px' }} />
                                        )}
                                    </Link>}
                                    {isurl !=='mahuaplay.ottsnap.in'&&
                                    <Link to={`/search/${slugify(movie.name)}/${createEncodedData(movie.id,movie.type_id, movie.video_type, movie.upcoming_type)}`} >
                                    {(movie.is_premium || movie.is_rent !== 0) && (
                                          <img
                                            src={movie.is_premium ? subscribe : rentIcon}
                                            className={`premium-img ${movie.is_premium ? 'premium-style' : ''}`}
                                            alt="Premium/Rent Icon"
                                          />
                                        )}
                                        {movie.thumbnail ? (
                                            <img src={imageLoaded[key] ? movie.thumbnail : logo} 
                                            onLoad={() => handleImageLoad(key)} 
                                            onError={addDefaultImg}
                                            className="img-top" alt={movie.name} style={{ height: '230px' }} />
                                        ) : (
                                            <img src={imageLoaded[key] ? movie.image : logo} 
                                            onLoad={() => handleImageLoad(key)}
                                            onError={addDefaultImg}
                                            className="img-top" alt={movie.name} style={{ height: '230px' }} />
                                        )}
                                    </Link>}
                                </div>
                            </div>
                        ))}
                        {seriesData.map((movie, key) => (
                            <div className="custom-div" key={key}>
                                <div className="card movie-card">
                                    {isurl ==='mahuaplay.ottsnap.in'&& movie.type_id !== 5 &&
                                    <Link to={`/search/${slugify(movie.name)}/${createEncodedData(movie.id,movie.type_id, movie.video_type, movie.upcoming_type)}`} >
                                    {(movie.is_premium || movie.is_rent !== 0) && (
                                          <img
                                            src={movie.is_premium ? subscribe : rentIcon}
                                            className={`premium-img ${movie.is_premium ? 'premium-style' : ''}`}
                                            alt="Premium/Rent Icon"
                                          />
                                        )}
                                        {movie.thumbnail ? (
                                            <img src={imageLoaded[key] ? movie.thumbnail : logo} 
                                            onLoad={() => handleImageLoad(key)}
                                            onError={addDefaultImg}
                                            className="img-top" alt={movie.name} style={{ height: '230px' }} />
                                        ) : (
                                            <img src={imageLoaded[key] ? movie.image : logo} 
                                             onLoad={() => handleImageLoad(key)}
                                            onError={addDefaultImg}
                                            className="img-top" alt={movie.name} style={{ height: '230px' }} />
                                        )}
                                    </Link>}
                                    {isurl !=='mahuaplay.ottsnap.in' &&
                                    <Link to={`/search/${slugify(movie.name)}/${createEncodedData(movie.id,movie.type_id, movie.video_type, movie.upcoming_type)}`} >
                                    {(movie.is_premium || movie.is_rent !== 0) && (
                                          <img
                                            src={movie.is_premium ? subscribe : rentIcon}
                                            className={`premium-img ${movie.is_premium ? 'premium-style' : ''}`}
                                            alt="Premium/Rent Icon"
                                          />
                                        )}
                                        {movie.thumbnail ? (
                                            <img src={imageLoaded[key] ? movie.thumbnail : logo} 
                                            onLoad={() => handleImageLoad(key)} 
                                            onError={addDefaultImg}
                                            className="img-top" alt={movie.name} style={{ height: '230px' }} />
                                        ) : (
                                            <img src={imageLoaded[key] ? movie.image : logo} 
                                            onLoad={() => handleImageLoad(key)}
                                            onError={addDefaultImg}
                                            className="img-top" alt={movie.name} style={{ height: '230px' }} />
                                        )}
                                    </Link>}
                                </div>
                            </div>
                        ))}
                    </div>
                    ) : (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh', color: 'white' }}>
                        <h2>No data available</h2>
                    </div>
                    )
                )}
            </div>
        </>    
    );
};

export default Search;